/**
 * Ordered onboarding steps — single source for stepper, setup panel, and navigation.
 */
export const SETUP_STEPS = [
	{
		key: 'hasProfileImage',
		label: 'Add your profile photo',
		shortLabel: 'Profile photo',
		headingTitle: 'Show Your Style',
		panelTitleUpper: 'Show your style',
		actionLabel: 'Add your profile photo',
		description:
			'Upload your profile image. Make it bold, unique, and a square (1:1 aspect ratio) to fit perfectly on the site.',
		anchorId: 'section-profile-media',
		route: null
	},
	{
		key: 'hasBannerImage',
		label: 'Add your banner image',
		shortLabel: 'Banner image',
		headingTitle: 'Set the Stage',
		panelTitleUpper: 'Set the stage',
		actionLabel: 'Add your banner image',
		description:
			'Add your banner image. This high-resolution masterpiece (2000 × 1000, 2:1 aspect ratio) will shine on your artist page and feature spots.',
		anchorId: 'section-profile-media',
		route: null
	},
	{
		key: 'hasBio',
		label: 'Add your artist bio',
		shortLabel: 'Bio',
		headingTitle: 'Tell Your Story',
		panelTitleUpper: 'Tell your story',
		actionLabel: 'Add your artist bio',
		description:
			'Upload your bio. In at least 125 words, share your journey, highlight your wins, and give fans a glimpse into your future.',
		anchorId: 'section-bio',
		route: null
	},
	{
		key: 'hasEnoughSongs',
		label: 'Upload at least one track',
		shortLabel: 'Upload music',
		headingTitle: 'Drop Your Tracks',
		panelTitleUpper: 'Drop your tracks',
		actionLabel: 'Upload your tracks',
		description:
			'Upload a minimum of one track in .wav format. Once uploaded, set your 30-second preview markers to give fans a taste of your sound.',
		anchorId: null,
		route: '/bands/music'
	},
	{
		key: 'hasStripeSetup',
		label: 'Set up payouts with Stripe',
		shortLabel: 'Stripe payouts',
		headingTitle: 'Get Paid Securely',
		panelTitleUpper: 'Get paid securely',
		actionLabel: 'Set up Stripe payouts',
		description:
			'Set up your free, secure Stripe account—this is your gateway to payouts. Subscriptions earned this month will be in your Stripe account by next month.',
		stripeHint: 'Payouts run through Stripe. Your bank details stay with Stripe, not on Muzado.',
		anchorId: 'section-stripe',
		route: null
	}
];

export function getStepDefinitionByKey (key) {
	return SETUP_STEPS.find((s) => s.key === key) || null;
}

export function getNextIncompleteStep (searchStatus) {
	if (!searchStatus) {
		return SETUP_STEPS[0];
	}

	for (const step of SETUP_STEPS) {
		if (!searchStatus[step.key]) {
			return step;
		}
	}

	return null;
}

export function isProfileSetupComplete (searchStatus) {
	if (!searchStatus) {
		return false;
	}

	return SETUP_STEPS.every((step) => searchStatus[step.key]);
}

export function goToSetupStep (step) {
	if (!step) {
		return;
	}

	if (step.route) {
		window.location.hash = `#${step.route}`;
	} else if (step.anchorId) {
		const el = document.getElementById(step.anchorId);

		if (el) {
			el.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}
}
